import PageLayout from "@/components/PageLayout";
import Services from "@/components/Services";
import SEO from "@/components/SEO";

export default function ServiziPage() {
  return (
    <PageLayout>
      <SEO
        title="Servizi · Psicologia, Sessuologia, Comunicazione Ipnotica"
        description="Servizi offerti a Chivasso (TO): psicologia clinica, sessuologia clinica, comunicazione ipnotica. Sedute in studio e online. Prenota una seduta."
        keywords="psicologia clinica Chivasso, sessuologia clinica Torino, comunicazione ipnotica, sedute online"
        path="/servizi"
      />
      <div data-testid="servizi-page" className="pt-24">
        <Services />
      </div>
    </PageLayout>
  );
}
